import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=00d08183&"
import script from "./contextMenu.vue?vue&type=script&lang=ts&"
export * from "./contextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./contextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports